<template>
    <div id="app">

        <div style="width: 100%; height: 40%; padding-left: 0.5%; padding-right: 0.5%; padding-top: 0.85%; padding-bottom: 0.25%">

            <v-card style="width: 32%; height: 100%;  float: left;  margin-right: 0.25%" color="white">

                <div @mouseenter="showUKstatsToggle = true" @mouseleave="showUKstatsToggle = false" @click="showMoreUkStats" style="width: 100%; height: 100%">

                    <div style="width: 100%; height: 15%; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 2vh; color: rgba(0,0,0,0.6)">

                        <div style="width: 80%; height: 100%; float: left; display: flex; justify-content: center; align-items: center; padding-left: 20%">
                            Revenue in £
                        </div>

                        <div style="width: 20%; height: 100%; float: left; display: flex; justify-content: center; align-items: center">
                            <v-fade-transition>
                           <v-icon v-if="showUKstatsToggle" style="font-size: 2vh">{{showUkIconToggle}}</v-icon>
                            </v-fade-transition>
                        </div>


                    </div>
                    <div style="width: 100%; height: 85%;display: flex; justify-content: center; align-items: center;">
                        <div style="width: 100%; height: 100%;" v-if="showUkDetailStats == true">
                           <div style="width: 50%; height: 80%; float: left;">

                               <div style="width: 100%; height: 30%; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 1.5vh; color: rgba(0,0,0,0.6);">
                                   Against Average
                               </div>

                               <div style="width: 100%; height: 70%; display: flex; justify-content: center; align-items: center; font-weight: bold; color: rgba(0,0,0,0.6)">
                                   <div style="width: 30%; height: 100%; padding-left: 20%">
                                       <div v-if="arrowDirection == 0" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; float: left;">
                                           <v-scroll-y-reverse-transition>
                                           <v-icon v-if="moveArrows" :color="arrowColor" style="font-size: 3.5vh">{{arrowIcon}}</v-icon>
                                           </v-scroll-y-reverse-transition>
                                       </div>

                                       <div v-if="arrowDirection == 1" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; float: left;">
                                           <v-scroll-y-transition>
                                               <v-icon v-if="moveArrows" :color="arrowColor" style="font-size: 3.5vh">{{arrowIcon}}</v-icon>
                                           </v-scroll-y-transition>
                                       </div>

                                       <div v-if="arrowDirection == 2" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; float: left;">
                                           <v-fade-transition>
                                               <v-icon v-if="moveArrows" :color="arrowColor" style="font-size: 3.5vh">{{arrowIcon}}</v-icon>
                                           </v-fade-transition>
                                       </div>

                                   </div>
                                   <div v-bind:style="{color: arrowColor}" style="width: 70%; height: 100%; display: flex; justify-content: center; align-items: center; float: left; font-size: 3vh; padding-right: 10%">
                                       {{ukPercentageDifference}}%
                                   </div>
                               </div>

                           </div>

                            <div style="width: 50%; height: 80%; float: left">
                                <div style="width: 100%; height: 30%; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 1.5vh; color: rgba(0,0,0,0.6);">
                                    Against Last Week
                                </div>

                                <div style="width: 100%; height: 70%; display: flex; justify-content: center; align-items: center; font-weight: bold; color: rgba(0,0,0,0.6)">
                                    <div style="width: 30%; height: 100%; display: flex; justify-content: center; align-items: center; float: left; padding-left: 20%">

                                        <div v-if="arrowDirectionweekly == 0" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; float: left;">
                                            <v-scroll-y-reverse-transition>
                                                <v-icon v-if="moveArrows" :color="arrowColorweekly" style="font-size: 3.5vh">{{arrowIconweekly}}</v-icon>
                                            </v-scroll-y-reverse-transition>
                                        </div>

                                        <div v-if="arrowDirectionweekly == 1" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; float: left;">
                                            <v-scroll-y-transition>
                                                <v-icon v-if="moveArrows" :color="arrowColorweekly" style="font-size: 3.5vh">{{arrowIconweekly}}</v-icon>
                                            </v-scroll-y-transition>
                                        </div>

                                        <div v-if="arrowDirectionweekly == 2" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; float: left;">
                                            <v-fade-transition>
                                                <v-icon v-if="moveArrows" :color="arrowColorweekly" style="font-size: 3.5vh">{{arrowIconweekly}}</v-icon>
                                            </v-fade-transition>
                                        </div>



                                    </div>
                                    <div v-bind:style="{color: arrowColorweekly}" style="width: 70%; height: 100%; display: flex; justify-content: center; align-items: center; float: left; font-size: 3vh; padding-right: 10%">
                                        {{weeklyDifferenceUK}}%
                                    </div>
                                </div>

                            </div>

                            <div style="width: 100%; height: 20%; font-weight: bold; font-size: 1.5vh; color: rgba(0,0,0,0.6);">
                                <div style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; float: left;">
                                  <v-icon style="padding-right: 5%; font-size: 2vh">fas fa-info-circle</v-icon>  Last weeks revenue £{{weeklysRevenue}}
                                </div>
                            </div>
                        </div>
                        <div v-else style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;">
                            <apexcharts style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;" class="radialBar"  width="100%" height="160%" :options="ukChartOptions" :series="ukSeries" />
                        </div>
                    </div>







                </div>






            </v-card>

   <v-card style="width: 32%; height: 100%;  float: left;  margin-left: 1.85%; margin-right: 1.85%" color="white">


       <div @mouseenter="showAusStatsToggle = true" @mouseleave="showAusStatsToggle = false" @click="showMoreAusStats" style="width: 100%; height: 100%">

           <div style="width: 100%; height: 15%; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 2vh; color: rgba(0,0,0,0.6)">

               <div style="width: 80%; height: 100%; float: left; display: flex; justify-content: center; align-items: center; padding-left: 20%">
                   Revenue in $
               </div>

               <div style="width: 20%; height: 100%; float: left; display: flex; justify-content: center; align-items: center">
                   <v-fade-transition>
                       <v-icon v-if="showAusStatsToggle" style="font-size: 2vh">{{showAusIconToggle}}</v-icon>
                   </v-fade-transition>
               </div>


           </div>
           <div style="width: 100%; height: 85%;display: flex; justify-content: center; align-items: center;">
               <div style="width: 100%; height: 100%;" v-if="showAusDetailStats == true">
                   <div style="width: 50%; height: 80%; float: left;">

                       <div style="width: 100%; height: 30%; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 1.5vh; color: rgba(0,0,0,0.6);">
                           Against Average
                       </div>

                       <div style="width: 100%; height: 70%; display: flex; justify-content: center; align-items: center; font-weight: bold; color: rgba(0,0,0,0.6)">
                           <div style="width: 30%; height: 100%; display: flex; justify-content: center; align-items: center; float: left; padding-left: 20%">
                               <div v-if="arrowDirectionAus == 0" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; float: left;">
                                   <v-scroll-y-reverse-transition>
                                       <v-icon v-if="moveArrows" :color="arrowColorAus" style="font-size: 3.5vh">{{arrowIconAus}}</v-icon>
                                   </v-scroll-y-reverse-transition>
                               </div>

                               <div v-if="arrowDirectionAus == 1" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; float: left;">
                                   <v-scroll-y-transition>
                                       <v-icon v-if="moveArrows" :color="arrowColorAus" style="font-size: 3.5vh">{{arrowIconAus}}</v-icon>
                                   </v-scroll-y-transition>
                               </div>

                               <div v-if="arrowDirectionAus == 2" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; float: left;">
                                   <v-fade-transition>
                                       <v-icon v-if="moveArrows" :color="arrowColorAus" style="font-size: 3.5vh">{{arrowIconAus}}</v-icon>
                                   </v-fade-transition>
                               </div>
                           </div>
                           <div v-bind:style="{color: arrowColorAus }" style="width: 70%; height: 100%; display: flex; justify-content: center; align-items: center; float: left; font-size: 3vh; padding-right: 10%">
                               {{ausPercentageDifference}}%
                           </div>
                       </div>

                   </div>

                   <div style="width: 50%; height: 80%; float: left">
                       <div style="width: 100%; height: 30%; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 1.5vh; color: rgba(0,0,0,0.6);">
                           Against Last Week
                       </div>

                       <div style="width: 100%; height: 70%; display: flex; justify-content: center; align-items: center; font-weight: bold; color: rgba(0,0,0,0.6)">
                           <div style="width: 30%; height: 100%; display: flex; justify-content: center; align-items: center; float: left; padding-left: 20%">
                               <div v-if="arrowDirectionweeklyAus == 0" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; float: left;">
                                   <v-scroll-y-reverse-transition>
                                       <v-icon v-if="moveArrows" :color="arrowColorweeklyAus" style="font-size: 3.5vh">{{arrowIconweeklyAus}}</v-icon>
                                   </v-scroll-y-reverse-transition>
                               </div>

                               <div v-if="arrowDirectionweeklyAus == 1" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; float: left;">
                                   <v-scroll-y-transition>
                                       <v-icon v-if="moveArrows" :color="arrowColorweeklyAus" style="font-size: 3.5vh">{{arrowIconweeklyAus}}</v-icon>
                                   </v-scroll-y-transition>
                               </div>

                               <div v-if="arrowDirectionweeklyAus == 2" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; float: left;">
                                   <v-fade-transition>
                                       <v-icon v-if="moveArrows" :color="arrowColorweeklyAus" style="font-size: 3.5vh">{{arrowIconweeklyAus}}</v-icon>
                                   </v-fade-transition>
                               </div>
                           </div>
                           <div v-bind:style="{color:arrowColorweeklyAus}" style="width: 70%; height: 100%; display: flex; justify-content: center; align-items: center; float: left; font-size: 3vh; padding-right: 10%">
                               {{weeklyDifferenceAUS}}%


                           </div>
                       </div>

                   </div>

                   <div style="width: 100%; height: 20%; font-weight: bold; font-size: 1.5vh; color: rgba(0,0,0,0.6);">
                       <div style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; float: left;">
                           <v-icon style="padding-right: 5%; font-size: 2vh">fas fa-info-circle</v-icon>  Last weeks revenue ${{weeklysRevenueAus}}
                       </div>
                   </div>
               </div>
               <div v-else style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;">
                   <apexcharts style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;" class="radialBar"  width="100%" height="160%" :options="ausChartOptions" :series="ausSeries" />
               </div>
           </div>







       </div>





   </v-card>


            <v-card style="width: 32%; height: 100%;  float: left;" color="white">
                <div style="width: 100%; height: 15%; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 2vh; color: rgba(0,0,0,0.6)">
                        Transactions This Week
                </div>
                <div style="width: 100%; height: 85%; display: flex; justify-content: center; align-items: center;">


                    <apexcharts style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; padding-top: 5%" class="radialBar"  height="130%" :options="radialChartOptions" :series="radialSeries" />





                </div>

            </v-card>


        </div>

        <div style="width: 100%; height: 60%; padding-left: 0.5%; padding-right: 0.5%; padding-top: 0.25%; padding-bottom: 1%">

            <v-card style="width: 100%; height: 100%;">

                <div style="width: 100%; height: 15%; font-weight: bold; font-size: 2vh;">
                        <v-fade-transition>
                    <v-card v-if="showDates" flat style="color: rgba(0,0,0,0.6); width: 100%; height: 100%;display: flex; justify-content: center; align-items: center;">
                    Revenue of {{startOfWeekDate}} - {{endOfWeekDate}}
                    </v-card>
                        </v-fade-transition>
                </div>

                <div style="width: 100%; height: 85%; display: flex; justify-content: center; align-items: center;">
                    <apexcharts style="width: 100%" type="area" height="100%" :options="chartOptions" :series="series"/>
                </div>




            </v-card>
        </div>

    </div>
</template>



<script>
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import {AXIOS} from "../../../http-common";
import VueApexCharts from 'vue-apexcharts'
import FlagIcon from 'vue-flag-icon'

Vue.use(FlagIcon);


Vue.use(Vuetify)
Vue.use(VueApexCharts)
export default {

  components: {
    apexcharts: VueApexCharts
  },

  props: [

  ],

  data () {
      return {

          moveArrows: true,

          todayTransactionsUK: 0,
          todayTransactionsAdult: 0,
          todayTransactionsAustralia: 0,


          showTransactions: false,

          showUKstatsToggle: false,
          showUkIconToggle:'fas fa-dot-circle',
          showUkDetailStats: false,



          showAusStatsToggle: false,
          showAusIconToggle:'fas fa-dot-circle',
          showAusDetailStats: false,



          ausSeries: [0],
          ausChartOptions: {
              chart: {
                  height: 450,
                  type: 'radialBar',

              },
              plotOptions: {
                  radialBar: {
                      startAngle: -135,
                      endAngle: 135,
                      dataLabels: {
                          name: {
                              fontSize: '16px',
                              color: undefined,
                              offsetY: 120
                          },
                          value: {
                              offsetY: -10,
                              fontSize: '5vh',
                              enabledOnSeries: [],
                              color: undefined,
                              formatter: function (val, opts) {
                                  var firstValue = opts.config.plotOptions.radialBar.dataLabels.value.enabledOnSeries[0]
                                  if (isNaN(firstValue)){
                                      var returnTotalValue = 0
                                  }
                                  else {
                                      returnTotalValue = firstValue
                                  }
                                  return '$' + returnTotalValue;
                              }
                          }
                      }
                  }
              },
              fill: {
                  type: 'gradient',
                  gradient: {
                      shade: 'dark',
                      shadeIntensity: 0.15,
                      inverseColors: false,
                      opacityFrom: 1,
                      opacityTo: 1,
                      stops: [0, 50, 65, 91]
                  },
              },
              stroke: {
                  dashArray: 4
              },
              labels: [''],
              colors: [''],
          },






          ukSeries: [0],
          ukChartOptions: {
              chart: {
                  height: 450,
                  type: 'radialBar',

              },
              plotOptions: {
                  radialBar: {
                      startAngle: -135,
                      endAngle: 135,
                      dataLabels: {
                          name: {
                              fontSize: '16px',
                              color: undefined,
                              offsetY: 120
                          },
                          value: {
                              offsetY: -10,
                              fontSize: '5vh',
                              enabledOnSeries: [],
                              color: undefined,
                              formatter: function (val, opts) {
                                  var firstValue = opts.config.plotOptions.radialBar.dataLabels.value.enabledOnSeries[0]
                                  if (isNaN(firstValue)){
                                      var returnTotalValue = 0
                                  }
                                  else {
                                      returnTotalValue = firstValue
                                  }
                                  return '£' + returnTotalValue;
                              }
                          }
                      }
                  }
              },
              fill: {
                  type: 'gradient',
                  gradient: {
                      shade: 'dark',
                      shadeIntensity: 0.15,
                      inverseColors: false,
                      opacityFrom: 1,
                      opacityTo: 1,
                      stops: [0, 50, 65, 91]
                  },
              },
              stroke: {
                  dashArray: 4
              },
              labels: [''],
              colors: [''],
          },

























          radialSeries: [0,0,0],
          radialChartOptions: {
              chart: {
                  height: 350,
                  type: 'radialBar',
              },
              plotOptions: {
                  radialBar: {
                      dataLabels: {
                          name: {
                              fontSize: '2.5vh',
                          },
                          value: {
                              fontSize: '2.5vh',
                              enabledOnSeries: [],
                              formatter: function (val,opts) {
                                  var firstValue = opts.config.plotOptions.radialBar.dataLabels.value.enabledOnSeries[0]
                                  var secondValue = opts.config.plotOptions.radialBar.dataLabels.value.enabledOnSeries[1]
                                  var thirdValue = opts.config.plotOptions.radialBar.dataLabels.value.enabledOnSeries[2]

                                  if (val == opts.config.series[2]){
                                      var returnThis = thirdValue
                                  }
                                  else if (val == opts.config.series[1]){
                                      var returnThis = secondValue
                                  }
                                  else if (val == opts.config.series[0]){
                                      var returnThis = firstValue
                                  }
                                  return returnThis;
                              }
                          },
                          total: {
                              show: true,
                              fontSize: '2.5vh',
                              label: 'Total',
                              formatter: function (val) {
                                  var totalValue = val.config.plotOptions.radialBar.dataLabels.value.enabledOnSeries[0] +
                                      val.config.plotOptions.radialBar.dataLabels.value.enabledOnSeries[1] +
                                      val.config.plotOptions.radialBar.dataLabels.value.enabledOnSeries[2]

                                  if (isNaN(totalValue)){
                                      var returnTotalValue = 0
                                  }
                                  else {
                                      returnTotalValue = totalValue
                                  }
                                  return returnTotalValue;
                              }
                          }
                      }
                  }
              },
              stroke: {
                  lineCap: 'round'
              },
              labels: ['UK', 'Australia', 'Adult'],
              colors: ['#ff6e49', '#fabe3f', '#529ca7'],
          },








          todaysDate: new Date(),
          showChart: false,
          series: [{
              name: "Revenue in £",
              data: [0,0,0,0,0,0,0]
              },
              {
              name: "Revenue in $",
                  data: [0,0,0,0,0,0,0]
              }
          ],
          chartOptions: {
              chart: {
                  height: 350,
                  type: 'spline',
                  zoom: {
                      enabled: false
                  },
                  toolbar: {
                      show: false
                  }
              },
              dataLabels: {
                  enabled: false
              },
              legend: {
                  position: 'top'
              },
              stroke: {
                  curve: 'smooth'
              },

              grid: {
                  row: {
                      colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                      opacity: 0.5
                  },
              },
              xaxis: {
                  categories: [
                      'Monday',
                      'Tuesday',
                      'Wednesday',
                      'Thursday',
                      'Friday',
                      'Saturday',
                      'Sunday'
                  ],

                  // categories: ['00:00', '01:00', '2 am' ,'3 am','4 am','5 am','6 am','7 am','8 am','9 am','10 am','11 am', ],

              },
              colors: ['#ad4aff', '#ff9524'],
          },

          ukRevenueToday: 0,
          ukAverageDaily:'',

          ausRevenueToday: 0,
          ausAverageDaily:'',

          ukPercentageDifference:'',
          arrowIcon:'',
          arrowColor:'',
          arrowDirection:'',

          ausPercentageDifference:'',
          arrowIconAus:'',
          arrowColorAus:'',
          arrowDirectionAus:'',


          weeklyDifferenceUK:'',
          arrowIconweekly:'',
          arrowColorweekly:'',
          arrowDirectionweekly:'',

          weeklyDifferenceAUS:'',
          arrowIconweeklyAus:'',
          arrowColorweeklyAus:'',
          arrowDirectionweeklyAus:'',




          daysResponse:'',
          daysResponseAUS:'',
          weeklysRevenue:0,
          weeklysRevenueAus:0,

          currentWeek:'',
          startOfWeekDate:'',
          endOfWeekDate:'',
          showDates: false,
      }





  },
  watch: {


  },
  created: function () {


      this.getCurrentWeek()
      this.getDOW()







  },
  computed: {



  },
  methods: {


      getDOW(){
          AXIOS({
              method: 'GET',
              url: '/api/dayofweek',
              headers: {
                  Authorization: 'Bearer ' + window.$cookies.get('session'),
                  'Access-Control-Allow-Origin': '*'
              }
          }).then(response => {
              this.dayOfWeek = response.data[0]
              var dayDiff = this.dayOfWeek - 1
              var nowDate = new Date().getDate()
              var startOfWeekDate = nowDate - dayDiff

              var setStartDate = new Date().setDate(startOfWeekDate)
              this.startOfWeekDate = new Date(setStartDate).toLocaleDateString()

              var endOfWeekDate = startOfWeekDate + 6
              var setEndDate = new Date().setDate(endOfWeekDate)
              this.endOfWeekDate = new Date(setEndDate).toLocaleDateString()
              this.showDates = true




          })
      },

      getMethods(){
          this.getAverageUKdaily()
          this.getUKrevenue()
          this.getAUSrevenue()
          this.getAverageAUSdaily()
          this.getThisWeeksTransactions()
          setInterval(this.arrowAnimation, 5000)
          this.getHourlyStats()
      },


      getHourlyStats(){
          Promise.all([
              AXIOS.get('/api/orders/stats/weekly/dayRevenue/uk', {headers: {Authorization: 'Bearer ' + window.$cookies.get('session'),  'Access-Control-Allow-Origin': '*'}}),
              AXIOS.get('/api/orders/stats/weekly/dayRevenue/aus', {headers: {Authorization: 'Bearer ' + window.$cookies.get('session'),  'Access-Control-Allow-Origin': '*'}}),

          ])
              .then(((response) => {



                  var responseDateUk = response[0].data
                  var responseDateAus = response[1].data

                  var p = 0;
                  while (p < responseDateUk.length){

                      var testo = responseDateUk[p][1]-1
                      this.series[0].data.splice(testo,1, responseDateUk[p][2]);
                      p++
                  }

                  var i = 0;
                  while (i < responseDateAus.length){
                      var ausRemoveFix = responseDateAus[i][1]-1
                      this.series[1].data.splice(ausRemoveFix,1, responseDateAus[i][2]);
                      i++
                  }

                  this.uk24Hours =  this.series[0].data;
                  this.aus24Hours = this.series[1].data;

                  setTimeout(() => this.update24HourChart(), 250)
              }))
      },

      update24HourChart(){
          this.series[0].data.map(() => {
              return
          })

          this.series[1].data.map(() => {
              return
          })
          // In the same way, update the series option
          this.series = [
              {
                  data: this.uk24Hours
              },
              {
                  data: this.aus24Hours
              }
          ]
      },

      getCurrentWeek(){
          AXIOS({
              method: 'GET',
              url: '/api/currentWeek',
              headers: {
                  Authorization: 'Bearer ' + window.$cookies.get('session'),
                  'Access-Control-Allow-Origin': '*'
              }
          }).then(response => {
              this.currentWeek = response.data[0]
              this.getMethods()
          })
      },

      pushTransactions(){
          this.radialSeries.map(() => {
              return
          })
          this.radialSeries = [this.ukPercentage.toFixed(0),this.ausPercentage.toFixed(0), this.adultPercentage.toFixed(0)]
      },

      getThisWeeksTransactions(){
          Promise.all([
              AXIOS.get('/api/orders/stats/weekly/transactions/1', {headers: {Authorization: 'Bearer ' + window.$cookies.get('session'),  'Access-Control-Allow-Origin': '*'}}),
              AXIOS.get('/api/orders/stats/weekly/transactions/2', {headers: {Authorization: 'Bearer ' + window.$cookies.get('session'),  'Access-Control-Allow-Origin': '*'}}),
              AXIOS.get('/api/orders/stats/weekly/transactions/3', {headers: {Authorization: 'Bearer ' + window.$cookies.get('session'),  'Access-Control-Allow-Origin': '*'}}),
          ])
              .then(((response) => {

                  // console.log(response)


                  if (response[0].data[0][0] == this.currentWeek){
                      this.todayTransactionsUK = response[0].data[0][2]
                  }
                  else {
                      this.todayTransactionsUK = 0
                  }
                  if (response[1].data[0][0] == this.currentWeek){
                      this.todayTransactionsAdult = response[1].data[0][2]
                  }
                  else {
                      this.todayTransactionsAdult = 0
                  }
                  if (response[2].data[0][0] == this.currentWeek){
                      this.todayTransactionsAustralia = response[2].data[0][2]
                  }
                  else {
                      this.todayTransactionsAustralia = 0
                  }
                  this.totalToday = response[2].data[0][2] + response[1].data[0][2] + response[0].data[0][2]

                  this.radialChartOptions.plotOptions.radialBar.dataLabels.value.enabledOnSeries.push(this.todayTransactionsUK, this.todayTransactionsAustralia, this.todayTransactionsAdult)

                  this.ukPercentage = this.todayTransactionsUK / this.totalToday * 100
                  this.adultPercentage =  this.todayTransactionsAdult / this.totalToday * 100
                  this.ausPercentage = this.todayTransactionsAustralia / this.totalToday * 100

                  setTimeout(() => this.pushTransactions(), 250)
              }));
      },

      showMoreUkStats(){
          this.showUkDetailStats = !this.showUkDetailStats

          if (this.showUkDetailStats == true){
              this.showUkIconToggle = 'far fa-dot-circle'
              this.showUkDetailStats = true
          }
          else if (this.showUkDetailStats == false){
              this.showUkIconToggle = 'fas fa-dot-circle'
              this.showUkDetailStats = false
          }
      },

      showMoreAusStats(){
          this.showAusDetailStats = !this.showAusDetailStats

          if (this.showAusDetailStats == true){
              this.showAusIconToggle = 'far fa-dot-circle'
              this.showAusDetailStats = true
          }
          else if (this.showAusDetailStats == false){
              this.showAusIconToggle = 'fas fa-dot-circle'
              this.showAusDetailStats = false
          }
      },


      getUKrevenue () {
          AXIOS({
              method: 'GET',
              url: '/api/orders/stats/weeklyRevenue/uk',
              headers: {
                  Authorization: 'Bearer ' + window.$cookies.get('session'),
                  'Access-Control-Allow-Origin': '*'
              }
          }).then(response => {
              this.daysResponse = response.data

              // console.log(this.daysResponse)

              this.getUkWeeklyComparison()

              if (response.data[0][0] == this.currentWeek){
                  this.ukRevenueToday = response.data[0][2]
              }
              else {
                  this.ukRevenueToday = 0
              }
              this.ukChartOptions.plotOptions.radialBar.dataLabels.value.enabledOnSeries.push(this.ukRevenueToday)
              setTimeout(() => this.pushRevenueUk(), 250)
          })
      },




      pushRevenueUk(){
          var pushValue = this.ukRevenueToday / this.ukAverageDaily * 100 - 100 + 50

          if (pushValue <= 0){
              pushValue = 1
          }
          if (pushValue <= 24){
              this.ukChartOptions.colors.unshift('#ff6d48')
          }
          else if (pushValue <= 50 && pushValue >= 25){
              this.ukChartOptions.colors.unshift('#ffc105')
          }
          else if (pushValue >50 ){
              this.ukChartOptions.colors.unshift('#4CAF50')
          }
          this.ukSeries.map(() => {
              return
          })
          this.ukSeries = [pushValue]
          this.ukPercentageDifference = (this.ukRevenueToday/this.ukAverageDaily - 1) * 100
          this.ukPercentageDifference = this.ukPercentageDifference.toFixed(0)

          if (this.ukPercentageDifference > 0){
              // console.log("INCREASE")
              this.arrowColor = '#4aa94d'
              this.arrowDirection = 0
              this.arrowIcon = 'fas fa-arrow-up'
          }
          else if (this.ukPercentageDifference < 0){
              // console.log("DECREASE")
              if (this.ukPercentageDifference <= -1 && this.ukPercentageDifference >= -20){
                  this.arrowColor = '#ff9800'
              }
          else {
                  this.arrowColor = '#f44335'
              }
              this.ukPercentageDifference = Math.abs(this.ukPercentageDifference)
              this.arrowDirection = 1
              this.arrowIcon = 'fas fa-arrow-down'
          }
          else if (this.ukPercentageDifference == 0 ){
              this.ukPercentageDifference = 0
              this.arrowIcon = 'lens'
              this.arrowColor = ''
              this.arrowDirection = 2
          }
      },

      getAverageUKdaily () {
          AXIOS({
              method: 'GET',
              url: '/api/orders/stats/weeklyAverage/uk',
              headers: {
                  Authorization: 'Bearer ' + window.$cookies.get('session'),
                  'Access-Control-Allow-Origin': '*'
              }
          }).then(response => {
              this.ukAverageDaily = response.data

          })
      },

      getAUSrevenue () {
          AXIOS({
              method: 'GET',
              url: '/api/orders/stats/weeklyRevenue/aus',
              headers: {
                  Authorization: 'Bearer ' + window.$cookies.get('session'),
                  'Access-Control-Allow-Origin': '*'
              }
          }).then(response => {
              this.daysResponseAUS = response.data

              this.getAusWeeklyComparison()

              if (response.data[0][0] == this.currentWeek){
                  this.ausRevenueToday = response.data[0][2]
              }
              else {
                  this.ausRevenueToday = 0
              }
              this.ausChartOptions.plotOptions.radialBar.dataLabels.value.enabledOnSeries.push(this.ausRevenueToday)
              setTimeout(() => this.pushRevenueAus(), 250)
          })
      },

      pushRevenueAus(){
          var pushValue = this.ausRevenueToday / this.ausAverageDaily * 100 - 100 + 50
          if (pushValue <= 0){
              pushValue = 1
          }
          if (pushValue <= 24){
              this.ausChartOptions.colors.unshift('#ff6d48')
          }
          else if (pushValue <= 50 && pushValue >= 25){
              this.ausChartOptions.colors.unshift('#ffc105')
          }
          else if (pushValue > 50 ){
              this.ausChartOptions.colors.unshift('#4CAF50')
          }
          this.ausSeries.map(() => {
              return
          })
          this.ausSeries = [pushValue]
          this.ausPercentageDifference = (this.ausRevenueToday/this.ausAverageDaily - 1) * 100
          this.ausPercentageDifference = this.ausPercentageDifference.toFixed(0)

          if (this.ausPercentageDifference > 0){
              // console.log("INCREASE")
              this.arrowColorAus = '#4aa94d'
              this.arrowDirectionAus = 0
              this.arrowIconAus = 'fas fa-arrow-up'
          }
          else if (this.ausPercentageDifference < 0){
              // console.log("DECREASE")
              if (this.ausPercentageDifference <= -1 && this.ausPercentageDifference >= -20){
                  this.arrowColorAus = '#ff9800'
              }
              else {
                  this.arrowColorAus = '#f44335'
              }
              this.ausPercentageDifference = Math.abs(this.ausPercentageDifference)
              this.arrowDirectionAus = 1
              this.arrowIconAus = 'fas fa-arrow-down'
          }
          else if (this.ausPercentageDifference == 0 ){
              this.ausPercentageDifference = 0
              this.arrowIconAus = 'lens'
              this.arrowColorAus = ''
              this.arrowDirectionAus = 2
          }
      },

      getAverageAUSdaily () {
          AXIOS({
              method: 'GET',
              url: '/api/orders/stats/weeklyAverage/aus',
              headers: {
                  Authorization: 'Bearer ' + window.$cookies.get('session'),
                  'Access-Control-Allow-Origin': '*'
              }
          }).then(response => {
              this.ausAverageDaily = response.data
          })
      },

      arrowAnimation () {
          this.moveArrows = !this.moveArrows
          if (this.moveArrows == false) {
              setTimeout(() => this.moveArrows = true, 1000)
          }
      },

      getUkWeeklyComparison() {
          var todaysInteger = this.currentWeek
          if (this.daysResponse[0][0] == todaysInteger){
              var todays = this.daysResponse[0][2]
          }
          else {
              var todays = 0
          }

          var lastWeek = this.currentWeek - 1

          if (this.daysResponse[1][0] == lastWeek){
              var weekly = this.daysResponse[1][2]
              this.weeklysRevenue = this.daysResponse[1][2]
              this.weeklyDifferenceUK = (todays/weekly - 1) * 100
          }
          else {
              var weekly = 0
              this.weeklysRevenue = 0
              this.weeklyDifferenceUK = todays * 100
          }
          this.weeklyDifferenceUK = this.weeklyDifferenceUK.toFixed(0)

          if (this.weeklyDifferenceUK > 0){
              // console.log("INCREASE")
              this.arrowColorweekly = '#4aa94d'
              this.arrowDirectionweekly = 0
              this.arrowIconweekly = 'fas fa-arrow-up'
          }
          else if (this.weeklyDifferenceUK < 0){
              if (this.weeklyDifferenceUK <= -1 && this.weeklyDifferenceUK >= -20){
                  this.arrowColorweekly = '#ff9800'
              }
              else {
                  this.arrowColorweekly = '#f44335'
              }
              this.weeklyDifferenceUK = Math.abs(this.weeklyDifferenceUK)
              this.arrowDirectionweekly = 1
              this.arrowIconweekly = 'fas fa-arrow-down'
          }
          else if (this.weeklyDifferenceUK == 0 ){
              this.weeklyDifferenceUK = 0
              this.arrowIconweekly = 'lens'
              this.arrowColorweekly = ''
              this.arrowDirectionweekly = 2
          }


      },


      getAusWeeklyComparison() {
          var todaysInteger = this.currentWeek

          if (this.daysResponseAUS[0][0] == todaysInteger){
              var todays = this.daysResponseAUS[0][2]
          }
          else {
              var todays = 0
          }
          var lastWeek = todaysInteger - 1

          if (this.daysResponseAUS[1][0] == lastWeek){
              var weekly = this.daysResponseAUS[1][2]
              this.weeklysRevenueAus = this.daysResponseAUS[1][2]

              this.weeklyDifferenceAUS = (todays/weekly - 1) * 100
          }
          else {
              var weekly = 0
              this.weeklysRevenueAus = 0

              this.weeklyDifferenceAUS = todays * 100
          }
          this.weeklyDifferenceAUS = this.weeklyDifferenceAUS.toFixed(0)

          if (this.weeklyDifferenceAUS > 0){
              // console.log("INCREASE")
              this.arrowColorweeklyAus = '#4aa94d'
              this.arrowDirectionweeklyAus = 0
              this.arrowIconweeklyAus = 'fas fa-arrow-up'
          }
          else if (this.weeklyDifferenceAUS < 0){
              if (this.weeklyDifferenceAUS <= -1 && this.weeklyDifferenceAUS >= -20){
                  this.arrowColorweeklyAus = '#ff9800'
              }
              else {
                  this.arrowColorweeklyAus = '#f44335'
              }
              this.weeklyDifferenceAUS = Math.abs(this.weeklyDifferenceAUS)
              this.arrowDirectionweeklyAus = 1
              this.arrowIconweeklyAus = 'fas fa-arrow-down'
          }
          else if (this.weeklyDifferenceAUS == 0 ){
              this.weeklyDifferenceAUS = 0
              this.arrowIconweeklyAus = 'lens'
              this.arrowColorweeklyAus = ''
              this.arrowDirectionweeklyAus = 2
          }


      }
}

}
</script>

<style scoped>
    html, body {
        height: 100%;
        margin: 0;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        text-align: center;
        color: black;
        background-color: white;

        width: 100%;
        height: 100%;
        background-size: cover;
        overflow: hidden;
        /*padding: 1%;*/
    }


    .large-donut {
      width: 45%;
      height: 100%;
      float: left;
    }

    .donut {
      width: 100%;
      height: 90%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .total-area{

      width: 55%;
      height: 100%;
      float: left


    }

    .total-area-nations {
      width: 100%; height: 40%;
    }

    .nations-divider {
      height: 100%; width: 50%; float: left;

    }

    .each-chat-summary {
      width: 100%; height: 40%;
    }

    .chat-divider {
      width: 33.3%; height: 100%; float: left;
    }
    .chat-color-blip-area {
      height: 15%; width: 100%; display: flex; justify-content: center; align-items: center
    }

    .chat-name-area {
      height: 15%; width: 100%; display: flex; justify-content: center; align-items: center; color: rgba(0,0,0,0.7); font-weight: bold; font-size: 2vh;
    }

    .chat-gen-divider {
      width: 100%; height: 70%
    }
    .gen-section {
      width: 100%; height: 33.3%
    }
    .gen-section-title {
      width: 50%; height: 100%; float: left; display: flex; justify-content: center; align-items: center; color: rgba(0,0,0,0.7); font-size: 0.8vw
    }
    .gen-section-data {
      width: 50%; height: 100%; float: left; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 0.9vw
    }

</style>
